/*
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import './WrcPageHeader.css';

import {Alignment} from "@blueprintjs/core/lib/esm/index";
import {Button} from "@blueprintjs/core";
import {IconNames} from "@blueprintjs/icons";
import {Navbar, NavbarGroup, NavbarHeading, NavbarDivider} from "@blueprintjs/core";
import PropTypes from "prop-types";

export class WrcPageHeader extends React.Component {
    logout = () => window.location.reload(true);

    sendEmail(e, emailto, emailsubj) {
        window.open('mailto:' + emailto + '?subject=' + emailsubj);
    }

    render() {
        return (
            <div>
                <Navbar className='bp3-dark' fixedToTop={false}>
                    <NavbarGroup align={Alignment.LEFT}>
                        <NavbarHeading>{this.props.project_name + ' — ' + this.props.title}</NavbarHeading>
                    </NavbarGroup>
                    <NavbarGroup align={Alignment.RIGHT}>
                        <Button className="bp3-minimal" icon={IconNames.ENVELOPE} text={'Get support'}
                                onClick={(e) => this.sendEmail(e, 'help@whiterivercomputing.com', 'Request for support')}/>
                        <NavbarDivider/>
                        <Button className="bp3-minimal" icon={IconNames.USER} text={'Welcome ' + this.props.username}/>
                        <Button className="bp3-minimal" icon={IconNames.LOG_OUT} text='Log out' onClick={this.logout}/>
                    </NavbarGroup>
                </Navbar>
                <div className={'wd-logos'}>
                    <div className={'bp3-text-muted'} style={{textAlign: 'center'}}>
                        <h2 className="bp3-heading">{this.props.site_name}</h2>
                    </div>
                </div>
            </div>
        );
    }
}

WrcPageHeader.propTypes = {
    project_name: PropTypes.string,
    title: PropTypes.string,
    username: PropTypes.string,
    site_name: PropTypes.string
};